module.exports = __webpack_public_path__ + "static/media/Golbat_gaussian2.449c4934.png";